let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("cM9em"), load("fr9NE"), load("8831k")]).then(() => parcelRequire('kXHaM'));